import React, {useState, useEffect} from 'react';
import LeadTopBarButton from './leadTopBarButton';
import { useSelector } from 'react-redux';
import { openAuthPopup } from '../../../../utilities/calendar';
import { useDispatch } from 'react-redux';
import BrandedButton, { brandedButtonTypes } from '../../../../utilities/inputComponents/BrandedButton';

function LeadCardTopBar({newEvent, from, setApptSet, setQualifier, handleSetScripting, qualifier, newEventPackage, calendarUsing, defaultCalendar, setEvent, newAppt, setNewAppt, update}) {
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const scopes=useSelector((state) => state.scopes.scopes);
    const dispatch=useDispatch();
    const [buttonInfo, setButtonInfo] = useState(['Attach File', 'Schedule Call', 'Appointment', 'Qualifier', 'Lead PDF']);
    const agentInfo = useSelector((state) => state.agent.userData);
    useEffect(() => {
        if (from === 'conversations') {
            setButtonInfo(prevButtonInfo => prevButtonInfo.filter(item => item !== 'Qualifier'));
        }
    }, [from]);

    const [buttonWrapperStyles, setButtonWrapperStyles] = useState({width: '94%', justifyContent: 'space-between', alignItems: 'center', gap: 5, display: 'inline-flex', marginLeft: '2%', marginBottom: '18px'})

    // Calculate actual rendered button count
    const getActualButtonCount = () => {
        let count = 0;
        buttonInfo.forEach(field => {
            // Count if Lead PDF exists OR if it's not Lead PDF
            if ((field === 'Lead PDF' && leadsAlldata?.pdf !== null) || field !== 'Lead PDF') {
                count++;
            }
        });
        return count;
    };

    const actualButtonCount = getActualButtonCount();

    useEffect(() => {
        if(leadsAlldata && leadsAlldata.pdf === null){
            setButtonWrapperStyles({
                width: '95%',
                gap: '5px',
                display: 'inline-flex',
                marginLeft: '2%',
                marginBottom: '18px'
            })
        }
    }, [])

    return (
         <div className="leadTopBarWrapper">
             <div className="leadTopBarInnerWrapper">
        <div style={{...buttonWrapperStyles}}>
            {buttonInfo.map((field, index) => (
                (field === 'Lead PDF' && leadsAlldata.pdf !== null) || field !== 'Lead PDF' ? (
                    scopes.length < 1  && field==='Appointment' ? (
                        // <div key={`topBarButton${index}`} className="leadCardButtonOuterWrapper" style={{flex: '1'}} onClick={()=>openAuthPopup(agentInfo.agentId, 'Google Auth', dispatch)}>
                        //     <div className="leadTopBarButton outlineQuilityInactiveButton">Appointment</div>
                        // </div>
                        // <div>
                            // <div style={{ width: '216px', height: '20px' }}>
                            <div key={`topBarButton${index}`} className="leadCardButtonOuterWrapper" style={{ minWidth: leadsAlldata.pdf === null ? '25%' : '20%', height: 35 , flex : '1'}}>
                                <BrandedButton
                                    buttonLabel='Appointment'
                                    clickHandler={_ => openAuthPopup(agentInfo.agentId, 'Google Auth', dispatch)}
                                    buttonType={brandedButtonTypes.SECONDARY}
                                    disabled={true}
                                    allowClickWhenDisabled={true}
                                />
                            </div>
                        // </div>
                    ) : (
                        <LeadTopBarButton newEvent={newEvent} setApptSet={setApptSet} handleSetScripting={handleSetScripting} update={update} key={`topBarButton${index}`} setQualifier={setQualifier} qualifier={qualifier} calendarUsing={calendarUsing} newAppt={newAppt} setNewAppt={setNewAppt} defaultCalendar={defaultCalendar} newEventPackage={newEventPackage} setEvent={setEvent} title={field} buttonCount={actualButtonCount} />
                    )
                ) : null
            ))}
             </div>
            </div>
         </div>
    );
}

export default LeadCardTopBar;